import { useCallback } from 'react'

import { useModal } from '@circlefin/modal-router'
import { routes } from '@services/sections/modal/routes'
import classNames from 'classnames'
import useTranslation from 'next-translate/useTranslation'

import * as Buttons from '../../../buttons'

export interface DefaultInvoiceHeaderProps {
  /**
   * Invoice id.
   */
  invoiceId: string
}

export const Default: React.FC<DefaultInvoiceHeaderProps> = ({ invoiceId }) => {
  const { t } = useTranslation('settings')
  const { router } = useModal()

  const onClick = useCallback(() => {
    router.push({
      pathname: routes.account.billing.payInvoice.paymentMethodSelection,
      query: { invoiceId },
    })
  }, [invoiceId, router])

  return (
    <div className="ml-auto w-3/5 text-right">
      <span data-testid="invoice-default-title">
        <Buttons.BillingDashboard onClick={onClick} variant="primary">
          {t('billing.invoices.details.summary.payInvoice')}
        </Buttons.BillingDashboard>
      </span>
      <div
        className={classNames(
          'py-2 mt-2 font-circular-regular leading-4 text-black-200',
          'text-s',
        )}
        data-testid="invoice-payment-due-sub-text"
      >
        {t('billing.invoices.details.summary.info')}
      </div>
    </div>
  )
}
